/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { IWorkFlowProtocol } from 'app/shared/model/work-flow-protocol.model';

export interface IWorkFlowStep {
  id?: string;
  name?: string;
  description?: string | null;
  sequence?: number;
  approvalRequired?: boolean | null;
  unitsOfMeasure?: string | null;
  valueType?: string | null;
  valueRange?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  role?: IClinicalDictionary | null;
  stepType?: IClinicalDictionary | null;
  protocol?: IWorkFlowProtocol | null;
}

export const defaultValue: Readonly<IWorkFlowStep> = {
  approvalRequired: false,
  active: false,
};
